<script setup>
import { ref, computed, watch } from 'vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useAlert } from 'dashboard/composables';

const props = defineProps({
  settings: { type: Object, required: true },
  isSaving: { type: Boolean, default: false },
});

const emit = defineEmits(['save']);

const enabled = ref(props.settings.absence_alert_enabled);
const delayMinutes = ref(props.settings.absence_alert_delay_minutes || 30);
const managerId = ref(props.settings.rodizio_manager_user_id);

watch(() => props.settings, s => {
  enabled.value = s.absence_alert_enabled;
  delayMinutes.value = s.absence_alert_delay_minutes || 30;
  managerId.value = s.rodizio_manager_user_id;
}, { deep: true });

const managers = computed(() => props.settings.managers || []);

const save = () => {
  if (enabled.value && !managerId.value) {
    useAlert('Selecione um gestor para receber os alertas');
    return;
  }

  emit('save', {
    absence_alert_enabled: enabled.value,
    absence_alert_delay_minutes: Math.max(1, Number(delayMinutes.value) || 30),
    rodizio_manager_user_id: managerId.value || null,
  });
};
</script>

<template>
  <div class="flex flex-col gap-6 w-full">
    <section class="border border-n-strong bg-n-background rounded-lg p-5 flex items-center justify-between gap-4">
      <div>
        <h2 class="text-body-large text-n-slate-12 font-medium m-0">
          Alerta de possível falta
        </h2>
        <p class="text-body-small text-n-slate-11 m-0">
          Notifica o gestor quando um funcionário ainda tem atendimentos vinculados e não aparece no sistema após o início do expediente.
        </p>
      </div>
      <Switch :model-value="enabled" @update:model-value="enabled = $event" />
    </section>

    <section class="border border-n-strong bg-n-background rounded-lg p-5 flex flex-col gap-4">
      <header>
        <h2 class="text-body-large text-n-slate-12 font-medium m-0">
          Regra de disparo
        </h2>
        <p class="text-body-small text-n-slate-11 m-0">
          O padrão é disparar 30 minutos após o início do expediente geral ou individual.
        </p>
      </header>

      <div class="grid grid-cols-2 gap-4 max-md:grid-cols-1">
        <div class="flex flex-col gap-1.5">
          <label class="text-body-small text-n-slate-12 font-medium">
            Atraso após o início do expediente
          </label>
          <div class="flex items-center gap-2">
            <input
              v-model.number="delayMinutes"
              type="number"
              min="1"
              max="240"
              class="w-24 border border-n-strong rounded-md py-2 px-3 bg-n-background text-n-slate-12"
            />
            <span class="text-body-small text-n-slate-11">minutos</span>
          </div>
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-body-small text-n-slate-12 font-medium">
            Gestor que recebe o alerta
          </label>
          <select
            v-model="managerId"
            class="border border-n-strong rounded-md py-2 px-3 bg-n-background text-n-slate-12"
          >
            <option :value="null">Selecione um gestor</option>
            <option v-for="manager in managers" :key="manager.id" :value="manager.id">
              {{ manager.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="flex justify-end">
        <Button label="Salvar alerta" :is-loading="isSaving" @click="save" />
      </div>
    </section>
  </div>
</template>
